<!--
 * @Author: FengXiao
 * @Date: 2020-07-27 16:59:52
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-10 00:57:30
-->
<template>
  <div class="zhiya-detail-page page-container">
    <video-player :datas="videoData" :speaker="speaker" :viplock="vip_lock"
      :allowEvent.sync="playerAllowEvent"></video-player>
    <div class="content">
      <episode-list :title="episodeTitle" :datas="episodeList" v-if="episodeList.length"
        @select="onSelectEpisode"></episode-list>
      <div class="container-wrap" :class="{ 'no-recommend': !recommendList.length }">
        <!-- 隐私改版：移除评论区，无文稿时显示占位提示 -->
        <div class="left-bl">
          <h1 class="detail_title">{{ topic.title }}</h1>
          <div class="detail_meta" v-if="detailMeta">{{ detailMeta }}</div>
          <div class="draft-empty">本篇暂无文稿</div>
        </div>
        <div class="right-bl">
          <recommend-videos :datas="recommendList" @click="onClickRecommend"></recommend-videos>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import VideoPlayer from '@/components/AppVideoPlayer';
import EpisodeList from '@/components/AppEpisodeList';
import RecommendVideos from '@/components/AppRecommendVideos';
import requestApi from '@/service';
export default {
  name: 'ZhiYaDetail',
  components: {
    VideoPlayer,
    EpisodeList,
    RecommendVideos,
  },
  data() {
    return {
      playerAllowEvent: false, // 允许当前视频支持键盘事件
      videoData: {},
      speaker: {},
      episodeList: [],
      recommendList: [],
      topic: {},
      episodeTitle: '',
      episodeId: null,
      vip_lock: false,
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    $route(to) {
      if (to.path === '/zhiya/detail') {
        this.init();
      }
    },
  },
  computed: {
    detailMeta() {
      // 讲者 · 日期（枝桠接口无城市字段）
      return [this.speaker && this.speaker.name, this.topic.date].filter(Boolean).join(' · ');
    },
  },
  methods: {
    init() {
      Object.assign(this.$data, this.$options.data());
      this.zhiyaId = this.$route.query.id || '';
      this.episodeId = this.$route.query.episodeId;
      this.refreshPage();
      this.initScrollTop();
    },
    refreshPage() {
      this.getData();
      this.getRecommend();
    },
    getData() {
      requestApi(`/v3/api/site/zhiya/${this.episodeId}/detail/`).then(({ items, speaker, base }) => {
        const { cover, video_url, title, first_category, date, titlelanguage, member_type } = this.getCurEpisode(items);
        if (!this.zhiyaId) {
          this.zhiyaId = base.id;
          this.getRecommend();
        }
        // 使用 map 方法替换 video_url 中的 http:// 为 https://
        const updatedVideoUrls = video_url.map(item => {
          if (item.video_url) {
            item.video_url = item.video_url.replace('http:', 'https:');
          }
          return item;
        });
        this.videoData = {
          cover,
          videoUrls: updatedVideoUrls,
          intro: titlelanguage,
        };
        this.topic = {
          title,
          category: first_category,
          date,
          intro: titlelanguage,
        };
        document.title = `${title} - 一席`;
        if (member_type == 2) {
          // 隐私改版：付费内容一律上锁，引导下载一席App观看
          this.vip_lock = true
        }
        this.speaker = speaker;
        this.episodeTitle = this.speaker.name;
        this.episodeList = items;
      });
    },
    getRecommend() {
      if (this.zhiyaId) {
        const url = `/v3/api/site/zhiya/${this.zhiyaId}/recommend/`;
        requestApi(url).then(({ recommended }) => {
          this.recommendList = recommended && recommended.length ? recommended : [];
        });
      }
    },
    /**
     * @description: 获取当前播放集
     */
    getCurEpisode(data = this.episodeList) {
      return data.filter(item => item.is_current)[0];
    },
    /**
     * @description: 选分集
     */
    onSelectEpisode(data) {
      this.gotoZhiYaDetail(this.zhiyaId, data.id, 0);
    },
    onClickRecommend(episodeId) {
      this.gotoZhiYaDetail('', episodeId);
    },
    gotoZhiYaDetail(id, episodeId) {
      this.$router.push({
        path: '/zhiya/detail',
        query: {
          id,
          episodeId,
        },
      });
    },
    inputFocus(val) {
      if (val) {
        this.playerAllowEvent = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.detail_title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  line-height: 1.5;
  margin: 4px 0 8px;
}

.detail_meta {
  font-size: 14px;
  color: #999;
  line-height: 1.5;
  margin: 0 0 20px;
}

.video-actions-bl {
  position: relative;
  width: 100%;
  text-align: center;
}

.content {
  .container-wrap {
    // 无推荐内容时左栏撑满整行
    &.no-recommend {
      .left-bl {
        width: 100%;
        max-width: 100%;
      }
      .right-bl {
        display: none;
      }
    }

    display: flex;
    align-items: flex-start;
    margin: 10px auto 100px;
  }

  .left-bl {
    width: 72%;
    max-width: 827px;
    margin-right: 10px;
    box-sizing: border-box;
    background: $C1;
    padding: 20px;
  }

  .right-bl {
    width: 28%;
    background-color: $C10;
  }
}

.draft-empty {
  padding: 80px 0;
  text-align: center;
  font-size: 14px;
  color: #999999;
}
</style>
